import { ajax } from '@/api/ajax'

//预习任务
//1、获取教学预习任务分页
export const reqTaskList = (paramets) => ajax(`/previewTask/queryPreviewTask`, paramets)

//2、教学预习添加
export const reqTaskAdd = (paramets) => ajax(`/previewTask/addPreviewTask`, paramets, 'post')

//3、教学预习编辑
export const reqTaskEdit = (paramets) => ajax(`/previewTask/updatePreviewTask`, paramets, 'put')

//3、教学预习发布
export const reqTaskEditStatus = (paramets) => ajax(`/jxtask/jxTask/editTaskStatus`, paramets, 'put')

//4、教学预习通过id删除
export const reqTaskDel = (paramets) => ajax(`/jxtask/jxTask/delete`, paramets, 'delete')

//5、教学预习批量删除
export const reqTaskDeleteBatch = (paramets) => ajax(`/jxtask/jxTask/deleteBatch`, paramets, 'delete')

//6、获取教学预习任务通过id查询
export const reqTaskDetail = (paramets) => ajax(`/jxtask/jxTask/getTaskDetails`, paramets)

//7、获取教学预习任务数量
export const reqTaskCount = (paramets) => ajax(`/jxtask/jxTask/getTaskCont`, paramets)

//8、获取教学预习任务班级列表
// 学生学习总进度
export const reqTaskClassList = (paramets) => ajax(`/jxtask/jxTask/getTaskStuList`, paramets)

//9、获取教学预习任务留言列表
export const reqTaskCatelogList = (paramets) => ajax(`/jxtask/jxTask/queryJxTaskCatalogByMainId`, paramets)

//10、获取教学预习任务测验列表
export const reqTaskTestList = (paramets) => ajax(`/jxtask/jxTask/queryJxTaskTestByMainId`, paramets)

//11、获取学生学习内容进度
export const reqTaskTestListStudent = (paramets) => ajax(`/jxtask/jxTask/getTaskStuRes`, paramets)

//12、获取当前用户课程
export const reqTaskCourseList = (paramets) => ajax(`/jxcourse/jxCourse/NoPageList`, paramets)

//13、获取课程下的授课计划
export const reqTaskPlanList = (paramets) => ajax(`/jxplan/jxPlan/getPlanByCourseId`, paramets)

//14、获取课程计划下的班级
export const reqTaskCourseClassList = (paramets) => ajax(`/jxplan/jxPlan/getClassByCourseId`, paramets)

//15、获取课程计划下的树
export const reqTaskCourseTreeList = (paramets) => ajax(`/jxplan/jxPlan/getCatalogByCourse`, paramets)

//16、获取任务下的讨论
export const reqTaskTalkList = (paramets) => ajax(`/jxtask/jxTaskStuMessage/getMessageList`, paramets)

//16、获取任务下的讨论回复
export const reqTaskTalkAdd = (paramets) => ajax(`/jxtask/jxTaskStuMessage/add`, paramets, 'post')

//16、获取任务下的讨论删除
export const reqTaskTalkDel = (paramets) => ajax(`/jxtask/jxTaskStuMessage/delete`, paramets, 'delete')

//16、获取任务下的讨论阅读
export const reqTaskTalkRead = (paramets) => ajax(`/jxtask/jxTaskStuMessage/editIsLook`, paramets, 'put')

//17、获取任务下的测验未参与人员
export const reqTaskTestStuList = (paramets) => ajax(`/jxtask/jxTask/getWcyTaskTestStu`, paramets)

//17、获取任务下的测验详情
export const reqTaskTestDetails = (paramets) => ajax(`/jxtask/jxTask/getTestList`, paramets)

//18、获取任务下的测验详情
export const reqEditEndTime = (paramets) => ajax(`/jxtask/jxTask/editPermission`, paramets, 'put')
